export default "__VITE_ASSET__C7hLUSRC__"